import gql from 'graphql-tag'

export const QUERY_GET_DRE_REVENUE_INCREMENT_METRICS = gql`
  query DreRevenueIncrementMetrics($input: DREMetricsInput) {
    dreRevenueIncrementMetrics(input: $input) {
      generalMetrics {
        increment
        discount
        incrementalRevenue
      }
      periodMetrics {
        dailyMetrics {
          date
          metrics {
            increment
            discount
            incrementalRevenue
          }
        }
      }
      detailsMetrics {
        total {
          discount
          increment
          productsRevenue
          totalClients
        }
        clusterMetrics {
          actives {
            totalClients
            increment
            discount
            productsRevenue
          }
          inactives {
            totalClients
            increment
            discount
            productsRevenue
          }
          losses {
            totalClients
            increment
            discount
            productsRevenue
          }
          firstBuy {
            totalClients
            increment
            discount
            productsRevenue
          }
        }
      }
    }
  }
`

export const QUERY_GET_DRE_OFFERS_COUPONS_METRICS = gql`
  query DreOffersCouponsMetrics($input: DREMetricsInput!) {
    dreOffersCouponsMetrics(input: $input) {
      insideLoyaltyClub {
        totalCoupons
        eligibleCoupons
        eligiblePercentageCoupons
      }
      outsideLoyaltyClub {
        totalCoupons
        eligibleCoupons
        eligiblePercentageCoupons
      }
    }
  }
`

export const QUERY_GET_DRE_PRODUCTS_METRICS = gql`
  query dreProductsMetrics($input: DREMetricsInput!) {
    dreProductsMetrics(input: $input) {
      bestProductsOnOffers {
        product {
          _id
          sku
          ean
          eans
          name
          image
        }
        metrics {
          revenue
          uplift
          incrementalRevenue
          daysOnOffer {
            quantity
            percentage
          }
          firstBuy {
            quantity
            percentage
          }
        }
      }
      worstProductsOnOffers {
        product {
          _id
          sku
          ean
          eans
          name
          image
        }
        metrics {
          revenue
          uplift
          incrementalRevenue
          daysOnOffer {
            quantity
            percentage
          }
          firstBuy {
            quantity
            percentage
          }
        }
      }
      bestProductsOutOffers {
        product {
          _id
          sku
          ean
          eans
          name
          image
        }
        metrics {
          revenue
          uplift
        }
      }
    }
  }
`

export const QUERY_GET_DRE_CLIENTS_DISTRIBUTION_BEFORE = gql`
  query DreClientsDistributionBefore($input: DREMetricsInput!) {
    dreClientsDistributionBefore(input: $input) {
      actives {
        quantity
        percentage
      }
      recentInactives {
        quantity
        percentage
      }
      atRisk {
        quantity
        percentage
      }
      losses {
        quantity
        percentage
      }
      neverBought {
        quantity
        percentage
      }
    }
  }
`

export const QUERY_GET_DRE_CHANNELS_DISTRIBUTION = gql`
  query DreChannelsDistribution($input: DREMetricsInput!) {
    dreChannelsDistribution(input: $input) {
      sms {
        quantity
        percentage
      }
      push {
        quantity
        percentage
      }
      email {
        quantity
        percentage
      }
      whatsapp {
        quantity
        percentage
      }
      notReceived {
        quantity
        percentage
      }
      total {
        quantity
      }
    }
  }
`

export const QUERY_GET_DRE_OFFERS_SCHEDULES_RESULT = gql`
  query DreOffersSchedulesResult($input: DREMetricsInput!) {
    dreOffersSchedulesResult(input: $input) {
      hasOffersSchedulesResult
    }
  }
`
